var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchieldIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.252 3.99057L8.00219 1.55224L13.7524 3.99057C13.9378 4.06913 14.0383 4.23566 14.0352 4.39277C14.0226 7.26473 12.8286 12.2262 8.1813 14.4509C8.06818 14.5043 7.93621 14.5043 7.82623 14.4509C3.1758 12.2231 1.98491 7.26473 1.9692 4.38963C1.9692 4.23252 2.06661 4.06913 2.252 3.98743V3.99057ZM14.34 2.60173L8.42324 0.0911233C8.29127 0.0314218 8.14988 0 8.00219 0C7.85451 0 7.71311 0.0314218 7.58114 0.0911233L1.66441 2.60173C0.973128 2.89395 0.45781 3.5758 0.460952 4.39906C0.476663 7.5161 1.75867 13.2192 7.17266 15.8115C7.6974 16.0628 8.30698 16.0628 8.83173 15.8115C14.2489 13.2192 15.5277 7.5161 15.5434 4.39906C15.5466 3.5758 15.0313 2.89395 14.34 2.60173ZM11.5529 6.56716C11.8482 6.2718 11.8482 5.79419 11.5529 5.50196C11.2575 5.20974 10.7799 5.2066 10.4877 5.50196L6.99984 8.98979L5.52301 7.51296C5.22764 7.2176 4.75003 7.2176 4.45781 7.51296C4.16559 7.80833 4.16244 8.28594 4.45781 8.57816L6.46881 10.5892C6.76417 10.8845 7.24178 10.8845 7.53401 10.5892L11.5529 6.56716Z",
    fill: "#3B6CCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchieldIconImage);
export default __webpack_public_path__ + "static/media/schieldIconImage.6ef620a67e75638f2aee7f97752bd1f5.svg";
export { ForwardRef as ReactComponent };